import { Component, OnInit, ViewChild, Inject, HostListener } from '@angular/core';
import { GridDataService } from '../../../service/grid-data.service';
import { TemplatesService } from '../../../service/templates.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as XLSX from 'xlsx';
import { GridOptions } from 'ag-grid-community';
import { FILE_UPLOAD_TIMEOUT, generateRandomString } from 'src/app/constants';
import { WebSocketService } from 'src/app/service/websocket.service';
import { environment } from 'src/environments/environment';
import { catchError, EMPTY, takeWhile, timeout } from 'rxjs';
@Component({
	selector: 'app-upload-template',
	templateUrl: './upload-template.component.html',
	styleUrls: ['./upload-template.component.scss'],
	standalone: false,  // NOSONAR
})
export class UploadTemplateComponent implements OnInit {
	gridApi: any;
	templateFile: any;
	columnDefs;
	rowData = [];
	successMessage = '';
	errorMessage = '';
	context: any;
	gridColumnApi: any;
	gridOptions: GridOptions;
	@ViewChild('agGrid', { static: true }) agGrid;
	arrayBuffer: any;
	isSuccess = false;
	dragAreaClass = 'droparea';
	isValidFile: boolean;
	selectedFileName: any;
	selectedFilePath: any;
	constructor(private readonly gridDataService: GridDataService, private readonly templatesService: TemplatesService,
		public dialogRef: MatDialogRef<UploadTemplateComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
		private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly webSocketService: WebSocketService) {
		this.context = {
			componentParent: this
		};
		this.gridOptions = { suppressRowClickSelection: true }
		this.columnDefs = [
			{
				headerName: "", width: 5, autoHeight: true, wrapText: true,
				cellRenderer: (_params) => {
					return '<mat-icon class="mat-icon material-icons" style="color:red" role="img">cancel</mat-icon>'
				}
			},
			{
				headerName: "ROW", width: 25, autoHeight: true, wrapText: true, field: "row"
			},
			{
				headerName: "COLUMN", width: 32, autoHeight: true, wrapText: true, field: "column"
			},
			{
				headerName: "FIELD(S)", width: 60, autoHeight: true, wrapText: true, field: "field"
			},
			{
				headerName: "VALUE", width: 60, autoHeight: true, wrapText: true, field: "value"
			},
			{
				headerName: "MESSAGE", width: 90, autoHeight: true, wrapText: true, field: "message"
			}
		]
	}
	ngOnInit(): void { // NOSONAR
		//  do something
	}
	onClick(event) {
		event.target.value = '';
	}
	fileChange(event) {
		if (event.target.files.item(0)) {
			this.templateFile = event.target.files.item(0);
			this.validateFile();
		}
	}
	onFileSelected(event) {
		if (event.target.files.item(0)) {
			this.templateFile = event.target.files.item(0);
			this.validateFile();
			const parsedFileName = this.templateFile?.name
				?.replace(/\s+/g, '_') // Replace spaces with underscore
				?.replace(/[^a-zA-Z0-9._]/g, '_'); // Replace all non-alphanumeric/safe characters with underscore
			this.selectedFileName = `${generateRandomString()}_${parsedFileName}`;
			this.selectedFilePath = `TaskManager/Import/${this.selectedFileName}`;
		}
	}
	importFile() {
		this.validateFile();
		if (!this.isValidFile) {
			this.isSuccess = false;
			this.errorMessage = 'Please select valid Template file';
			this.successMessage = '';
			this.resetMessages();
			return;
		}
		this.ngxUiLoaderService.start("loader-01");
		this.rowData = [];
		this.templatesService.uploadTemplate(this.templateFile, this.data.templateId).subscribe(data => {
			if (data && data.length > 0) {
				this.isSuccess = false;
				this.rowData = data;
				this.errorMessage = 'Validation Failed. Please find Error details below.';
				this.successMessage = '';
			} else {
				this.isSuccess = true;
				this.successMessage = 'Template File uploaded successfully!';
				this.errorMessage = '';
			}
			this.resetMessages();
			this.ngxUiLoaderService.stop("loader-01");
		}, _error => {
			this.isSuccess = false;
			this.errorMessage = 'Validation Failed. Please try again with valid template file.';
			this.successMessage = '';
			this.resetMessages();
			this.ngxUiLoaderService.stop("loader-01");
		});
	}
	async newimportFile() {
		this.validateFile();
		if (!this.isValidFile) {
			this.isSuccess = false;
			this.errorMessage = 'Please select valid Template file';
			this.successMessage = '';
			this.resetMessages();
			return;
		}
		this.ngxUiLoaderService.start("loader-01");
		this.rowData = [];
		try {
			this.webSocketService.connect();
			await this.webSocketService.waitUntilSocketConnected();
			console.info(
				'WebSocket connected:',
				this.webSocketService.isSocketConnected()
			);
			this.webSocketService.sendMessage(
				// JSON.stringify({
				{ fileName: this.selectedFilePath }
				// })
			);
			const url = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePath}`;
			const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
			const upn = fgaDetails?.user?.userPrincipalName;
			const uploadHeaders: any = {
				'Content-Type': this.templateFile?.type, // Set file content type
				'x-amz-meta-authtoken': sessionStorage.getItem('accessToken'),
				'x-amz-meta-userid': upn,
				'x-amz-meta-templateid': this.data.templateId,
				'x-auth-token': sessionStorage.getItem('accessToken')
			};
			const response = await fetch(url, {
				method: 'PUT',
				headers: uploadHeaders,
				body: this.templateFile,
			});
			if (!response.ok) {
				this.ngxUiLoaderService.stop("loader-01");; // 🛑 Stop spinner on error
				this.errorMessage = 'Failed to upload file!'
				this.resetMessages()
				this.webSocketService.closeConnection();
				return;
			}
			this.webSocketService
				.receiveMessages()
				.pipe(
					// If no message is received within 25 seconds, throw TimeoutError
					timeout({
						each: FILE_UPLOAD_TIMEOUT, // 25 seconds between messages
					}),
					takeWhile((msg) => msg.status != 'success' && msg.status != 'failed' && msg.status != 'error', true), // NOSONAR
					catchError((err) => {
						if (err.name == 'TimeoutError') { // NOSONAR
							console.info(
								`No message received in ${FILE_UPLOAD_TIMEOUT / 1000
								} seconds. Closing connection.`
							);
							this.ngxUiLoaderService.stop("loader-01");;
							this.webSocketService.closeConnection();
							this.errorMessage = 'Failed to upload file. Please re-upload the file.'
							this.resetMessages()
						} else {
							console.info('WebSocket error:', err);
						}
						return EMPTY; // Stop further emissions
					})
				)
				.subscribe((messages: any) => {
					console.info(messages, "messages from Lambda");
					const backendResp = messages.backendResponse;
					try {
						if (backendResp) {
							if (messages.status) {
								const data = backendResp
								if (data && data.length > 0) {
									this.isSuccess = false;
									this.rowData = data;
									this.errorMessage = 'Validation Failed. Please find Error details below.';
									this.successMessage = '';
								} else if (data && data.length == 0) { // NOSONAR
									this.isSuccess = true;
									this.successMessage = 'Template File uploaded successfully!';
									this.errorMessage = '';
								}
								else {
									this.isSuccess = false;
									this.errorMessage = 'File Upload Failed!';
									this.resetMessages();
								}
								this.resetMessages();
								this.ngxUiLoaderService.stop("loader-01");
								this.webSocketService.closeConnection();
							}
							else {
								this.isSuccess = false;
								this.errorMessage = 'File Upload Failed!';
								this.resetMessages();
								this.ngxUiLoaderService.stop("loader-01");
								this.webSocketService.closeConnection();
							}
						}
					}
					catch {
						this.isSuccess = false;
						this.errorMessage = 'Validation Failed. Please try again with valid template file.';
						this.successMessage = '';
						this.resetMessages();
						this.ngxUiLoaderService.stop("loader-01");
						this.webSocketService.closeConnection();
					}
					this.ngxUiLoaderService.stop("loader-01");
				})
		} catch (err) {
			console.info('Unexpected upload exception:', err);
			this.ngxUiLoaderService.stop("loader-01");
			this.webSocketService.closeConnection();
			this.errorMessage = 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists'
		}
	}
	resetMessages() {
		setTimeout(() => {
			this.successMessage = '';
			this.errorMessage = '';
		}, 6500);
	}
	onGridReady(params: any) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridApi.sizeColumnsToFit();
	}
	sizeToFit() {
		this.gridApi.sizeColumnsToFit();
	}
	closeDialog(): void {
		this.dialogRef.close({ status: this.isSuccess });
	}
	validateFile() {
		if (!this.templateFile) {
			this.isValidFile = false;
		}
		const fileReader = new FileReader();
		fileReader.onload = _e => {
			this.arrayBuffer = fileReader.result;
			const data = new Uint8Array(this.arrayBuffer);
			const arr = [];
			for (let i = 0; i <= data.length; i++) {
				arr[i] = String.fromCharCode(data[i]);
			}
			const bstr = arr.join("");
			const workbook = XLSX.read(bstr, { type: "binary" })
			const firstSheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[firstSheetName];
			const excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
			if (excelData && excelData.length > 0) {
				this.isValidFile = true;
			} else {
				this.isValidFile = false;
			}
		}
		fileReader.readAsArrayBuffer(this.templateFile);
	}
	@HostListener('dragover', ['$event']) onDragOver(event) {
		this.dragAreaClass = 'droparea';
		event.preventDefault();
	}
	@HostListener('drop', ['$event']) onDrop(event) {
		this.dragAreaClass = 'droparea';
		event.preventDefault();
		event.stopPropagation();
		this.templateFile = event.dataTransfer.files.item(0);
	}
}
